import { CategoryModelType } from '@teinor/erp/types/company/category'
import { TwinDictionary } from '../../globals/dictionary'

export interface Category extends CategoryModelType {
    'CategoryLangs.name': string
    'name': string
    childs?: Category[]
    absoluteOrder: number
}
export interface OrganizedCategoriesTy {
    ogCategory: Category[]
    treeCategory: Category[]
}
type CategoriesOrganized = { [key: number]: OrganizedCategoriesTy }
export interface CategoriesPayload{
    organized: CategoriesOrganized
    dictionary: {[id: number]: Category}
}
export interface CategoriesAction {
    type: 'CHANGE_CATEGORIES'
    payload: Category[]
}


export function categories(state: CategoriesPayload | null = null, action: CategoriesAction): CategoriesPayload | null {
    switch (action.type) {
        case 'CHANGE_CATEGORIES':
            return state = organizeByMaterialType(action.payload)
        default:
            return state
    }
}


const organizeByMaterialType = (categories: Category[]) => {
    const result: CategoriesOrganized = {}
    const dictionary: CategoriesPayload['dictionary'] = {}
    let absoluteOrder = 1
    if (categories && categories.length) {
        const types = [0,1,5]
        for (const category of categories) {
            dictionary[category.id] = category
            if (category.id === 1) {
                const categoryMain = category
                dictionary[category.id]['absoluteOrder'] = 1
                dictionary[category.id]['name'] = 'Base'
                for (const type of types) {
                    if (!result[type]) {
                        result[type] = {
                            ogCategory: [JSON.parse(JSON.stringify(categoryMain))],
                            treeCategory: []
                        }
                    }    
                }
            } else {
                result[category?.categoryMaterialType]?.ogCategory.push(category)
            }
        }
        for (const type in result) {
            let { treeCategory, order } = makeTree(result[type].ogCategory, absoluteOrder, dictionary)
            result[type].treeCategory = treeCategory
            absoluteOrder = order
        }
    }
    return { organized: result, dictionary: dictionary }
}
const makeTree = (categories: Category[], absoluteOrder: number, dictionary: TwinDictionary) => {
    const result: any = []
    const index: any = {}
    for (const item of categories) {
        if (!item['CategoryLangs.name']) {
            if (item.id === 1) {
                item['CategoryLangs.name'] = 'Base'
            } else {
                item['CategoryLangs.name'] = '-'
            }
        }
        if (!item.CategoryId) {
            result.push(item)
            continue
        }
        if (index[item.CategoryId] === undefined) {
            index[item.CategoryId] = []
        }
        index[item.CategoryId].push(item)
    }
    for (const item of result) {
        absoluteOrder = recursiveTree(item, index, absoluteOrder, dictionary)
    }
    return { treeCategory: result, order: absoluteOrder }
}
const recursiveTree = (item: Category, map: any = {}, absoluteOrder: number, dictionary: TwinDictionary) => {
    item.childs = []
    if (map[item.id]) {
        const myMap = map[item.id].sort((a: any, b: any) => a.order - b.order)
        for (const sub of myMap) {
            absoluteOrder++
            dictionary[sub.id]['absoluteOrder'] = absoluteOrder
            absoluteOrder = recursiveTree(sub, map, absoluteOrder, dictionary)
            item.childs.push(sub)
        }
    }
    return absoluteOrder
}